/* ========== Configurazioni possibili per un enigma ========== */

import { StoryDto } from '../storie-enigmi/storie-dto';

export interface MultipleChoiceConfig {
  options: string[];
  correctOptionIndex: number;
}

export interface TrueFalseConfig {
  correctAnswer: boolean;
}

export interface NumericAnswerConfig {
  correctNumber: string;
}

export interface ImageQuizConfig {
  imageUrls: string[];
  correctImageIndex: number;
}

export interface AudioConfig {
  audioUrl: string;
  correctAnswer: string;
}

/* export interface EnigmaDto {
    id: string;
    name: string;
    description?: string;
    question?: string;
    type?: AnswerTypes;
    configurationJson?: string;
    createdAt: string;
    updatedAt: string;
    missionFk: string;
    stories: StoryDto[];
} */

export interface EnigmaDto {
  id: string;
  name: string;
  description: string;
  shortDescription: string;
  question?: string;
  type?: AnswerTypes;
  configurationJson?: string;
  createdAt: string;
  updatedAt: string;
  stepFk: string;
  dependsOn?: string;
  x?: number | null;
  y?: number | null;
  stories: StoryDto[];
  enigmaProgresses: EnigmaProgress[];
}

export interface EnigmaProgress {
  id: string;
  enigmaFk: string;
  teamFk: string;
  createdAt: string;
  updatedAt: string;
}

/* export interface CreateEnigma {
    name: string;
    description?: string;
    question?: string;
    type?: AnswerTypes;
    configurationJson?: MultipleChoiceConfig | TrueFalseConfig | NumericAnswerConfig | ImageQuizConfig | AudioConfig;
    missionFk: string;
}*/

export interface CreateEnigma {
  name: string;
  description: string;
  shortDescription: string;
  question?: string;
  type?: AnswerTypes;
  configurationJson?:
    | MultipleChoiceConfig
    | TrueFalseConfig
    | NumericAnswerConfig
    | ImageQuizConfig
    | AudioConfig;
  dependsOn?: string;
  x?: number | null;
  y?: number | null;
  stepFk: string;
}

/* export interface UpdateEnigma {
    name: string;
    description?: string;
    question?: string;
    type?: AnswerTypes;
    configurationJson?: MultipleChoiceConfig | TrueFalseConfig | NumericAnswerConfig | ImageQuizConfig | AudioConfig;
    missionFk: string;
} */

export interface UpdateEnigma {
  description: string;
  shortDescription: string;
  question?: string;
  type?: AnswerTypes;
  configurationJson?:
    | MultipleChoiceConfig
    | TrueFalseConfig
    | NumericAnswerConfig
    | ImageQuizConfig
    | AudioConfig;
  dependsOn?: string;
  x?: number | null;
  y?: number | null;
  stepFk: string;
  name: string;
}

export enum AnswerTypes {
  multiple = 'multiple_choice',
  trueFalse = 'true_false',
  numeric = 'numeric_answer',
  image = 'image',
  audio = 'audio',
}

export const ANSWER_TYPE_ICONS: Record<AnswerTypes, string> = {
  [AnswerTypes.multiple]: 'list', // <tabler-icon name="list" />
  [AnswerTypes.trueFalse]: 'check', // <tabler-icon name="check" />
  [AnswerTypes.numeric]: 'hash', // <tabler-icon name="hash" />
  [AnswerTypes.image]: 'photo', // <tabler-icon name="photo" />
  [AnswerTypes.audio]: 'volume-2', // <tabler-icon name="volume-2" />
};

export const ANSWER_TYPE_LABELS: Record<AnswerTypes, string> = {
  [AnswerTypes.multiple]: 'Scelta multipla',
  [AnswerTypes.trueFalse]: 'Vero/Falso',
  [AnswerTypes.numeric]: 'Risposta numerica',
  [AnswerTypes.image]: 'Immagine',
  [AnswerTypes.audio]: 'Audio',
};
